// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__iHIOD","checked":"Switch_checked__Myvou","disabled":"Switch_disabled__0Bqa5","thumb":"Switch_thumb__inAob"};